import { FlexBox } from '@dixa/lib-shared-habla';

import { ArticleContent } from '../../../ArticleContent';
import { ArticleRowProps } from '../../../ArticleRow/ArticleRow';
import styles from '../../../ArticleRow/ArticleRow.module.scss';
import { ArticleStatusBar } from '../../../ArticleStatusBar';
import { OpenArticleInTab } from '../../../OpenArticleInTab';

import { ArticleRadioInput } from './ArticleSelectRadioInput';

export function ArticleSelectOption({
  article,
  selectedArticleId,
  onSelectArticle,
}: ArticleRowProps): JSX.Element {
  const {
    accessControl: { isInternal },
    category: { title: categoryTitle },
    id: articleId,
    slug,
    tags: articleTags,
    title: articleTitle,
  } = article;
  const isSelected = articleId === selectedArticleId;

  const articleSlug = slug || '';

  return (
    <FlexBox
      className={styles.article}
      as="article"
      onClick={() => onSelectArticle({ articleId, articleTitle })}
      maxWidth="100%"
      title={articleTitle}
    >
      <ArticleRadioInput isSelected={isSelected} />
      <ArticleStatusBar isInternal={isInternal} />
      <ArticleContent
        className={styles.hover}
        articleTitle={articleTitle}
        articleTags={articleTags}
        categoryTitle={categoryTitle}
      />
      <FlexBox gap="300" alignItems="center" justifyContent="center">
        <OpenArticleInTab articleSlug={articleSlug} />
      </FlexBox>
    </FlexBox>
  );
}
